import { Component, Vue } from "vue-property-decorator";
import Template from "./Forbidden.template.vue";

@Component({
  mixins: [Template]
})
export default class ForbiddenComponent extends Vue {
  public back() {
    this.$router.back();
  }
}
